import { useRef } from "react";

const Scroller = ({ children, className }) => {
  const scrollRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);
  const handleMouseDown = (e) => {
    isDragging.current = true;
    startX.current = e.pageX - scrollRef.current.offsetLeft;
    scrollLeft.current = scrollRef.current.scrollLeft;
    scrollRef.current.style.cursor = "grabbing";
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = x - startX.current; // Distance moved
    scrollRef.current.scrollLeft = scrollLeft.current - walk;
  };

  const handleMouseUp = () => {
    isDragging.current = false;
    scrollRef.current.style.cursor = "default";
  };

  const handleMouseDoubleClick = () => {
    scrollRef.current.style.cursor = "grab";

  }
  return (<div
    ref={scrollRef}
    className={`flex gap-[12px] md:gap-4 w-full overflow-x-auto scrollbar-hide ${className}`}
    onMouseDown={handleMouseDown}
    onMouseMove={handleMouseMove}
    onMouseUp={handleMouseUp}
    onMouseLeave={handleMouseUp}
    ondblclick={handleMouseDoubleClick}
    style={{ cursor: "default" }}
  >
    {children}
  </div>)
}

export default Scroller;